<div class="event-table">
    <table mat-table [dataSource]="eventsDataSource" matSort matSortActive="id" matSortDirection="asc">
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
            <td mat-cell *matCellDef="let r"> {{r.id}} </td>
        </ng-container>
        <ng-container matColumnDef="shortName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Short name</th>
            <td mat-cell *matCellDef="let r"> {{r.shortName}} </td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let r"> {{r.name}} </td>
        </ng-container>
        <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
            <td mat-cell *matCellDef="let r"> {{r.location}} </td>
        </ng-container>
        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start date</th>
            <td mat-cell *matCellDef="let r"> {{r.date | date: 'dd/MM/yyyy'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>End date</th>
            <td mat-cell *matCellDef="let r"> {{r.endDate | date: 'dd/MM/yyyy'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="freeEvent">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Free event</th>
            <td mat-cell *matCellDef="let r">
                @if (r.freeEvent) {
                Yes
                } @else {
                No
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>Actions </th>
            <td mat-cell *matCellDef="let r">
                <button mat-icon-button color="primary" title="Edit" (click)="gotoRegistration(r)">
                    <mat-icon>info</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" (click)="gotoRegistration(row)"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data available</td>
        </tr>
    </table>
    <mat-paginator #attendeePaginator [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="showFirstLastButtons"></mat-paginator>
</div>